export default {
  inputKeyword: '请输入关键词',
  selectPlease: '请选择',
  inputBizOrderNo: '请输入业务委托号',
  inputProductOrderNo: '请输入产品委托号',
  pieceSmartInput: '每行一种，例如：\n120 80 60 10\n100×60×40×5',
  inputMawbNo: '请输入主单号',
  inputCustomer: '请输入客户名称',
  inputUsername: '请输入用户名',
  inputPassword: '请输入密码',
  dateRange: '选择日期范围',
  username: '用户名',
  password: '密码',
  captcha: '验证码',
  inputCaptcha: '请输入验证码',
  searchBizOrder: '搜索委托号 / 客户 / 单号...',
  dateStart: '开始',
  dateEnd: '结束',
  routeExample: '如 PVG-LAX',
  airlineExample: '如 CA',
  fuzzySearch: '模糊搜索',
  selectAtd: '选择实际起飞时间',
  selectAta: '选择实际到达时间',
  searchCustomer: '搜索客户名称/编号',
  inputCustomerName: '请输入客户名称',
  inputCustomerCode: '请输入客户编号',
  // users/Index.vue placeholders
  searchUser: '搜索用户名或姓名',
  inputRealName: '请输入姓名',
  selectRole: '请选择角色',
  selectOrg: '请选择组织机构',
  inputEmail: '请输入邮箱',
  inputPhone: '请输入电话',
  // dictionary/Index.vue placeholders
  searchDictionary: '搜索字典名称或编码',
  dictCodeExample: '如: cargo_type',
  dictNameExample: '如: 货物类型',
  dictNameEnExample: '如: Cargo Type',
  dictDescriptionEnExample: '如: Cargo type',
  itemCodeExample: '如: dangerous',
  itemNameExample: '如: 危险品',
  itemNameEnExample: '如: Dangerous Goods',
  inputDescription: '请输入描述',
  // agreement placeholders
  searchAgreement: '搜索协议编号/航司',
  searchAgreementOrder: '搜索协议委托编号',
  searchOrCreateAgreementNo: '搜索或新建协议编号（如 BSA-2026-CA）',
  agreementNoExample: '如 BSA-2026-Q2-CA',
  agreementEntrustNoExample: '如 BSA-2026-Q2-PVG-LAX-001',
  selectAirline: '请选择航司',
  selectAirlineOptional: '请选择航司（可空，事后补填）',
  originExample: '如 PVG',
  transitPortExample: '如 HKG（非必填）',
  transitPortMulti: '如有多个可用逗号分隔',
  destinationExample: '如 LAX',
  selectPalletType: '板型',
  inputCount: '数量',
  chargeableWeightPerUldPlaceholder: '单板配合（计费重量）',
  volumeWeightPlaceholder: '计费重量配额',
  selectDate: '选择日期',
  selectAirlineOptionalHint: '可空，事后补填',
  agreementDescriptionHint: '可填写协议详细描述、条款、约束等大文本内容',
  // system placeholders
  searchRole: '搜索角色名称/编码...',
  searchPermission: '搜索权限...',
  searchOrg: '搜索组织名称/编码/类别...',
  searchUsername: '搜索用户名',
  inputRoleCode: '请输入角色编码',
  inputRoleName: '请输入角色名称',
  inputRoleNameEn: '如: System Administrator',
  inputRoleDescription: '请输入角色描述',
  selectDataScope: '请选择数据权限',
  inputPermissionCodeExample: '请输入权限编码，如：system:user:add',
  inputPermissionName: '请输入权限名称',
  inputPermissionNameEn: '如: Users',
  inputPermissionCode: '请输入权限编码',
  selectParentPermission: '请选择上级权限（不选为顶级）',
  inputRoutePathExample: '请输入路由路径，如：/system/user',
  inputComponentPathExample: '请输入组件路径，如：system/user/index',
  inputIconExample: '请输入图标名称，如：User',
  selectPermissionType: '请选择权限类型',
  inputOrgCode: '请输入组织编码',
  inputOrgName: '请输入组织名称',
  inputOrgNameEn: '如: Headquarters',
  inputOrgTypeHint: '请输入组织类别（只用于标识）',
  selectParentOrg: '请选择上级组织（不选则为顶级）',
  inputOrgDescription: '请输入组织描述',
  startTime: '开始时间',
  endTime: '结束时间',
  // cs-workbench placeholders
  systemOrManualInput: '系统带出或手工录入',
  warehouseReceiptNoOptional: '仓库称重单号（可选）',
  departurePlace: '出发地',
  destinationPlace: '目的地',
  viewStatus: '查看状态',
  warehouseStatus: '入仓状态',
  // cs-workbench/BizOrderCreateDialog
  manualOrAutoBizOrderNo: '手工录入或留空自动生成',
  inputCustomerNameSearch: '请输入客户名称',
  customerCodeSystemOrManual: '系统带出或手工录入',
  inputContactName: '请输入联系人',
  inputContactPhone: '请输入联系电话',
  inputContactAddress: '请输入联系人地址',
  inputCustomerRemark: '请输入客户备注',
  departureExample: '如: PVG',
  finalDestinationExample: '如: 芝加哥',
  inputShippingTerms: '请输入运输条款',
  inputShipperName: '请输入发货人名称',
  inputConsigneeName: '请输入收货人名称',
  inputCargoDescription: '请输入货物品名',
  inputSpecialRemark: '请输入特殊备注',
  selectDateTime: '选择日期时间',
  // entry/dialogs
  selectReason: '选择原因',
  inputDissolveReason: '请输入撤舱原因',
  // entry/dialogs/AddMasterAirWaybillDialog
  inputMawbNoFormat: '请输入主单号，如 999-12345678',
  actualFlightNoExample: '如 CA981',
  selectEtd: '选择ETD',
  selectEta: '选择ETA',
  inputRemark: '请输入备注信息',
  // entry/dialogs/CreateProductOrderDialog
  flightNoExample: '如 CA123',
  selectProductType: '请选择产品类型',
  selectPleaseDash: '— 请选择 —',
  selectSubOrderCycle: '请选择子协议周期（W1/W2... 或 M1/M2...）',
  inputUnitPrice: '请输入单价',
  // entry/dialogs/EditProductOrderDialog
  linkAgreementOptional: '关联协议(可选)',
  // entry/components
  required: '必选',
  selectAgreementDash: '— 请选择协议 —',
  // entry/components/ChangeRequestDrawer
  inputRejectReason: '请输入驳回原因',
  // entry/components/CargoModeView
  groupMethod: '分组方式',
  searchBizOrCustomer: '搜索委托号/客户',
  // entry/components/RightPanel
  originPort: '始发港',
  destinationPortShort: '目的港',
  // entry/components/WarehouseConfirmDrawer
  selectMawbNo: '请选择主单号',
  autoGeneratedEditable: '自动生成，可手动修改',
  // entry/components/LeftPanel/ProductOrderList
  searchFlightOrRouteOrNo: '搜索航班号/航线/编号',
  // cs-workbench/components/CenterPanel/BizOrderForm/WarehouseDataSection
  optional: '可选',
  // 工作台左侧栏 ETD 日期段筛选
  etdStart: 'ETD开始日期',
  etdEnd: 'ETD结束日期',
}
